import {
  IGetOnboardingFlowResponse,
  IOnboardingModuleWithSteps,
} from '@Saral-Influencer-Marketing/saral-utils/src/types';

export const FETCH_ONBOARDING_VIDEOS_REQUEST = 'FETCH_ONBOARDING_VIDEOS_REQUEST';
export const FETCH_ONBOARDING_VIDEOS_SUCCESS = 'FETCH_ONBOARDING_VIDEOS_SUCCESS';
export const FETCH_ONBOARDING_VIDEOS_FAILURE = 'FETCH_ONBOARDING_VIDEOS_FAILURE';
export const UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS = 'UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS';

export interface OnboardingVideosState {
  videos: IOnboardingModuleWithSteps[];
  modulesCompletionData: Record<string, number>;
  loading: boolean;
  error: string | null;
}

interface FetchOnboardingVideosRequestAction {
  type: typeof FETCH_ONBOARDING_VIDEOS_REQUEST;
}

interface FetchOnboardingVideosSuccessAction {
  type: typeof FETCH_ONBOARDING_VIDEOS_SUCCESS;
  payload: IGetOnboardingFlowResponse;
}

interface FetchOnboardingVideosFailureAction {
  type: typeof FETCH_ONBOARDING_VIDEOS_FAILURE;
  payload: string;
}

interface UpdateOnboardingVideoStepProgressAction {
  type: typeof UPDATE_ONBOARDING_VIDEO_STEP_PROGRESS;
  payload: {
    stepId: string;
    isCompleted: boolean;
  };
}
export type OnboardingVideosActionTypes =
  | FetchOnboardingVideosRequestAction
  | FetchOnboardingVideosSuccessAction
  | FetchOnboardingVideosFailureAction
  | UpdateOnboardingVideoStepProgressAction;
